import React from "react";
import GraficoDiferenciaGeneral from "./GraficoDiferenciaGeneral";
import GraficoAvanceGeneral from "./GraficoAvanceGeneral";


class DashboardAvance extends React.Component {
    render() {
        return (
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'flex-start',
                gap: '10px',
                padding: '10px',
                maxWidth: '100%',
                boxSizing: 'border-box',
            }}>
                <div style={{minWidth: 400, height: 'auto'}}>
                    <GraficoAvanceGeneral datos={this.props.datos}/>
                </div>

                <div style={{width: 'auto', height: 'auto'}}>
                    <GraficoDiferenciaGeneral
                        datos_diferencia={this.props.datos_diferencia}
                        tipo_inv={this.props.tipo_inv}
                        estado_inv={this.props.estado_inv}
                        loading={this.props.loading}
                    />
                </div>
            </div>
        );
    }
}

export default DashboardAvance;